import {useState, useEffect} from 'react'
import {Aff_question} from "./Aff_question"
import {useFetch} from "../hooks/useFetch"
import {useMsg} from "../hooks/useMsg"
import {MathJax, MathJaxContext } from "better-react-mathjax";
import {clean} from "../Fonctions"


export function MesquestionsModif ({liste, id_serie, niv_serie, setActivModif, auth}) {

	const {data, data2, fetchApi, fetchApi2, errors, setErrors} = useFetch([])
	const {msg, setMsg, msg2, setMsg2} = useMsg([])
	const [maSerie, setmaSerie] = useState()
	const [questions, setquestions] = useState()
	const [questionsAll, setquestionsAll] = useState()
	const [num_question, setnum_question] = useState([])
	const [showFermer, setShowFermer] = useState(false)
	const [serieChanged, setSerieChanged] = useState(false)
	const [filtreEtoile, setFiltreEtoile] = useState('')
	const [onlyMyQuestions, setOnlyMyQuestions] = useState(false)

	useEffect(()=>{
		fetchApi('api-questions', {...auth, action:'RecupMaListe', id_serie, niveau:niv_serie})
		if (errors === 'err') {
			setMsg2('Une erreur est survenue, veuillez recharger la page.', 'alert danger')
		}
	},[]);

	useEffect(()=>{
		setmaSerie(data[0])
	},[data[0]]);

	useEffect(()=>{
		setquestions(data[1])
		setquestionsAll(data[1])
		if(data[1] !== undefined){
			setnum_question([Object.keys(data[1])[0], Object.keys(data[1])[1], Object.keys(data[1])[2]])
		}
	},[data[1]]);

	useEffect(()=>{
    if(typeof window?.MathJax !== "undefined"){
      window.MathJax.typeset()
    }
	},[num_question]);

	const titre_serie = Object.keys(liste).filter(elt => elt.split('__')[0] === id_serie)[0].split('__')[1]
	//const [MaSerie0, setMaSerie0] = useState(liste[id_serie+'__'+titre_serie])
	
	const handleClick = (e) => {
		if (!serieChanged) {
			setSerieChanged(true)
		}
		if (e.target.innerText === 'Retirer') {
			//setquestions({...questions, [e.target.name]:data[0][e.target.name]})
			let tab = {...maSerie}
			delete tab[e.target.name]
			setmaSerie(tab)
		}
		if (e.target.innerText === 'Ajouter') {
			//setquestions({...questions, [e.target.name]:data[0][e.target.name]})
			if(Object.keys(maSerie).length < 10) {
				setmaSerie({...maSerie, [e.target.name]:questions[e.target.name]})
			}
		}
		if (e.target.innerText === 'Mettre à jour') {
			fetchApi2('api-questions', {...auth, action:'MAJMaListe', id_serie, liste:Object.keys(maSerie).join('_'), niveau:niv_serie})
			if(errors === 'err') {
				setMsg('Une erreur est survenue, veuillez recommencer', 'alert danger')
				setErrors('')
			} else {
				setMsg('La série à bien été mise à jour.', 'success')
				setShowFermer(true)
			}
			//console.log('errors MAJ : ', errors)
			//console.log('data2 : ', data2)
			//console.log('data : ', data)
		}
	}
	const handleNav = (e) => {
		const k = Object.keys(questions).indexOf(num_question[0])
		//console.log('k :', k)
		//console.log('questions length :', Object.keys(questions).length)
		if(e.target.className === 'suivant' && k + 3 < Object.keys(questions).length) {
			const tab = [Object.keys(questions)[k+3], Object.keys(questions)[k+4], Object.keys(questions)[k+5]]
      setnum_question(tab) 
    }

		if(e.target.className === 'precedent' && k - 1 >= 0) {
			const tab = [Object.keys(questions)[k-3], Object.keys(questions)[k-2], Object.keys(questions)[k-1]]
      setnum_question(tab) 
    }

    /*window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth' // Ajoute un défilement fluide
    })*/
	}
	const handleFiltre = (e) => {
		let filtre_num_questions = []

		if (e.target.title === 'Recherche rapide') {
			const search = clean(e.target.value)
			filtre_num_questions = Object.keys(questionsAll).filter(num => 
				clean(questionsAll[num].join()).includes(search)
			)
			if(filtreEtoile) {
				filtre_num_questions = filtre_num_questions.filter(num => 
				questionsAll[num][1].split('*').length === filtreEtoile.split('⭐').length
				)
			}
		}
		if (e.target.title === 'etoile') {
			const nb_etoile = e.target.innerText.split('⭐').length

			filtre_num_questions = Object.keys(questionsAll).filter(num => 
				questionsAll[num][1].split('*').length === nb_etoile
			)
			setFiltreEtoile(e.target.innerText)
			setOnlyMyQuestions(false)
		}

		if (e.target.className === 'btn_param active') {
			filtre_num_questions = Object.keys(questionsAll)
			setFiltreEtoile('')
			setOnlyMyQuestions(false)
		}

		if (e.target.title === 'Uniquement mes questions' && !onlyMyQuestions) {
			filtre_num_questions = Object.keys(questionsAll).filter(num => 
				num.includes('created')
			)
			setOnlyMyQuestions(true)
		}
		if (e.target.title === 'Uniquement mes questions' && onlyMyQuestions) {
			filtre_num_questions = Object.keys(questionsAll)
			setOnlyMyQuestions(false)
		}


		let filtre_questions = {}
		filtre_num_questions.map(num => filtre_questions[num] = questionsAll[num])

		setquestions(filtre_questions)
		setnum_question([filtre_num_questions[0], filtre_num_questions[1], filtre_num_questions[2]])

		//console.log('questions : ', questions)
		//console.log('questionsAll : ', questionsAll)
		//console.log('filtre_num_questions : ', filtre_num_questions)
		//console.log('filtre_questions : ', filtre_questions)
	}

	const show_titre = () => {
		if (questions) {
			if(num_question[0] === Object.keys(questions)[0] && !serieChanged) {
				return <h1>Modification de la série {titre_serie}</h1>
			}
		}
	}

	const show_questions = (questions) => {
		if (questions !== undefined) {
			return [
						<Aff_question key={num_question[0]} key_tab={num_question[0]} question={questions[num_question[0]]} handleClick={handleClick} tag={"Ajouter"} />,
						<Aff_question key={num_question[1]} key_tab={num_question[1]} question={questions[num_question[1]]} handleClick={handleClick} tag={"Ajouter"} />,
						<Aff_question key={num_question[2]} key_tab={num_question[2]} question={questions[num_question[2]]} handleClick={handleClick} tag={"Ajouter"} />
					]
		}
	}

	const show_search = () => {
		return <>
			&emsp;Filtrer les questions :
			{
				['⭐', '⭐⭐', '⭐⭐⭐'].map((e, k) =>
					<span key={k} title="etoile" className={'btn_param'+(filtreEtoile === e ? ' active' : '')} onClick={handleFiltre}>{e}</span>
				)
			}
			&emsp;&emsp;&emsp; 
			<span className={'btn_param'+(onlyMyQuestions ? ' active' : '')} title="Uniquement mes questions" onClick={handleFiltre}>Uniquement mes questions</span>
			&emsp;&emsp;&emsp; 
			<input type="text" className="" title="Recherche rapide" onChange={handleFiltre} placeholder="Recherche rapide"/>
		</>
	}

	const show_ma_serie = (maSerie) => {
		if (maSerie !== undefined) {
			return Object.keys(maSerie).length === 0 ? 
				<div className='info'><br/>Votre série ne comporte aucune question<br/><br/></div> 
			: 
				Object.keys(maSerie).map((num, k)=><Aff_question key={k} key_tab={num} question={maSerie[num]} handleClick={handleClick} tag={"Retirer"} />)
		}
	}

	//console.log('data[0] : ', data[0])
	//console.log('data[1] : ', data[1])
	//console.log('data[2] : ', data[2])
	//console.log('questions : ', questions)
	//console.log('num_question : ', num_question)
	//console.log('maSerie : ', maSerie)
	//console.log('errors : ', errors)
	//console.log('filtreEtoile : ', filtreEtoile)

  return (
    <div className="content_modif_serie">
    	<div className="suppr_serie" onClick={()=>setActivModif(false)}></div>
    	{
    		show_titre(questions)
    	}
    	{
    		errors === 'err' ? <span dangerouslySetInnerHTML={{ __html:msg2}}></span> : ''
    	}
    	{
    		show_search()
    	}
    	<div>
	      <MathJaxContext>
		    	{
		    		show_questions(questions)
		    	}
	      </MathJaxContext>
    	</div>

    	<div className="precedent" onClick={handleNav}></div>
    	<div className="suivant" onClick={handleNav}></div>
    	<hr/>
    	<div className="etiquettes">
	    	{
	    		show_ma_serie(maSerie)
	    	}
	    	<br/>
	    	<span dangerouslySetInnerHTML={{ __html:msg}}></span>
    	</div>
    	{
    		showFermer || !serieChanged ?
    			<button className="btn center" onClick={()=>setActivModif(false)}>Fermer</button>
    		:
    			<button className="btn center" onClick={handleClick}>Mettre à jour</button>
    	}
    	<br/><br/>
    </div>
  );
}